import { __ } from '@wordpress/i18n';
import { VayuBlocksToggleControl } from '@vayu-blocks';

export const Responsive = ({ value, onChange }) => {
	const deviceLabels = {
		Desktop: __('Hide On Desktop', 'vayu-blocks'),
		Tablet: __('Hide On Tablet', 'vayu-blocks'),
		Mobile: __('Hide On Mobile', 'vayu-blocks'),
	};

	const currentKey = value.key;
	const currentValue = value.value || {};

	return (
		<>
			{Object.keys(deviceLabels).map((device) => (
				<VayuBlocksToggleControl
					key={device}
					label={deviceLabels[device]}
					checked={currentValue?.[device]}
					onChange={(newVal) =>
						onChange(currentKey, {
							...currentValue,
							[device]: newVal,
						})
					}
				/>
			))}
		</>
	);
};
